export default "__VITE_ASSET__Dn_v538i__"